import { NavLink } from 'react-router';

import { dayOf, describe } from '../../dates';
import { useLanguage } from '../../contexts/language';

import { ActionLink } from '../action-link';
import { BackLink } from '../back-link';
import { Initials } from '../initials';

import styles from './style.module.css';

// The top of every page about one patient, as the blueprint's Patient
// header draws it: the way back to Patients, who the patient is and since
// when they are connected, Assign test, and the record's tabs. The name is
// the page's h1; each tab's own title is an h2 below it. Tests and Diary
// exist so far; Overview, Sessions and Reports join with their features.
export function PatientHeader({ patient }) {
  const { text, language } = useLanguage();
  const { id, firstName, lastName, connectedSince } = patient;

  return (
    <div className={ styles.header }>
      <BackLink to='/patients'>{ text.patients }</BackLink>

      <div className={ styles.who }>
        <div className={ styles.identity }>
          <Initials firstName={ firstName } lastName={ lastName } large/>

          <div className={ styles.lines }>
            <h1 className={ styles.name }>{ `${ firstName } ${ lastName }` }</h1>
            <span className={ styles.since }>{ text.connectedSince.replace('{date}', describe({ day: dayOf(connectedSince), language, short: true })) }</span>
          </div>
        </div>

        <ActionLink to={ `/patients/${ id }/assign` }>{ text.assignTest }</ActionLink>
      </div>

      <nav className={ styles.tabs } aria-label={ text.patientRecord }>
        <NavLink className={ styles.tab } to={ `/patients/${ id }/tests` }>{ text.tests }</NavLink>
        <NavLink className={ styles.tab } to={ `/patients/${ id }/diary` }>{ text.diary }</NavLink>
      </nav>
    </div>
  );
}
